//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from 'vuex'

import pageMeta, { mxGetMeta } from '~/mixins/pageMeta'
import OffersInMailbox from '~/components/section/offers-in-mailbox'
import { asyncDataStart } from '~/utils/asyncData'
import urlTranslator from '~/middleware/url-translator'
import FaqItems from '~/components/Flotillas/FaqItems'
import faq from '~/mixins/faq'
import SearchOtherLocations from '~/components/search/page/search-other-locations.vue'
import PageTop from '~/components/section/page-top.vue'
import SearchComponent from '~/components/search/page/search-component.vue'
import searchUtils from '~/mixins/search/search-utils'
import SearchOtherBoatTypesInLocation from "~/components/search/page/search-other-boat-types-in-location.vue";;

export default {
  name: 'DestinationPage',
  components: {
    SearchOtherBoatTypesInLocation,
    SearchComponent,
    PageTop,
    OffersInMailbox,
    FaqItems,
    SearchOtherLocations
  },
  mixins: [pageMeta, faq, searchUtils],
  middleware: [urlTranslator],
  async asyncData (ctx) {
    await asyncDataStart(ctx)

    try {
      const lang = ctx.store.getters['lang/locale']
      const locationUrl = ctx.route.params.location
      const path = `/${lang}/destinations/${locationUrl}/` +
        (ctx.route.params.boatType ? `${ctx.route.params.boatType}/` : '')
      await mxGetMeta(ctx, {
        meta: {
          method: 'dynamic',
          type: 'destination',
          path,
          idx: locationUrl,
          params: {
            idx: locationUrl,
            boat_type: ctx.route.params.boatType
          }
        }
      })

      await ctx.store.dispatch('search/getLocation', { lang, locationUrl })
      await ctx.store.dispatch('search/getDestinationInfo', { lang, location: locationUrl, boatType: ctx.route.params.boatType })
      await ctx.store.dispatch('auth/getFavorites')
      return {
        lang,
        boat_type: ctx.route.params.boatType
      }
    } catch (e) {
      return ctx.redirect(301, ctx.app.router.resolve({ name: 'destinations' }).href)
    }
  },
  data () {
    return {
      page: {
        sticky: false
      },
      breadcrumbInformation: {},
      loadHero: false
    }
  },
  computed: {
    ...mapState({
      breakpoint: 'breakpoint',
      currentCurrency: state => state.lang.currentCurrency,
      pageSeoData: state => state.pageData,
      destinationData: state => state.search.destination,
      loading: state => state.search.loading,
      location: state => state.search.locationFull,
      filters: state => state.search.filters,
      results: state => state.search.results,
      amountResultsFound: state => state.search.amountResultsFound,
      locations: state => state.search.locations,
      hasBeenFiltered: state => state.search.hasBeenFiltered,
      pagination: state => state.search.pagination,
      staticReviews: 'staticReviews'
    }),
    ...mapGetters({
      bar: 'search/bar',
      pageFaq: 'page/pageFaq'
    }),
    boatTypes () {
      return this.$store.state.search.staticBoatTypes.map((t) => {
        return {
          ...t,
          name: t.translate ? this.$t(t.name.toLowerCase()) : t.name
        }
      })
    },
    getBoatTypeObj() {
      let name = null
      if (this.filters?.boat_types && Array.isArray(this.filters?.boat_types)) {
        name = this.filters?.boat_types?.find(t => t.slug === this.$route.params.boatType)
      }
      return name
    },
    getLocationName () {
      return (this.location.location)[this.location.type] || 'Tubber'
    },
    destinationText () {
      const dt = this.destinationData?.area?.description?.find(d => d.language === this.lang)
      let result = ''
      if (dt) {
        result = dt.name
      } else {
        result = this?.destinationData?.area?.description[0].name
      }

      result = result ? result.replaceAll('h2', 'h3') : ''
      if (result && result.substring(0, 2) !== '<h') {
        result = `<h2>${this.$t('rent-a-boat-in')} ${(this.location.location)[this.location.type] || 'Tubber'}</h2> \n \n` + result
      }
      result = result ? result.replaceAll('h1', 'h2') : ''

      const regexp = /^http:\/\//gi
      return result ? result.replaceAll(regexp, 'https://') : ''
    },
    getShowAllButton () {
      if (!this.$Search) {
        return {
          sliceCount: 3,
          text: this.$t('show-all') + ' ' + (this.amountResultsFound) + ' ' + this.$tc(`${this.$t('boat')} | ${this.$t('boats_low')}`, this.amountResultsFound),
          hrefLink: ''
        }
      }
      return {
        sliceCount: 3,
        text: this.$t('show-all') + ' ' + (this.amountResultsFound) + ' ' + this.$tc(`${this.$t('boat')} | ${this.$t('boats_low')}`, this.amountResultsFound),
        hrefLink: this.$Search.generateClientUrl()
      }
    }
  },
  watch: {
    'breakpoint.current' () {
      this.loadHero = !!(this.breakpoint.current && this.breakpoint.current !== 'isMobile');
    }
  },
  mounted () {
    this.$Search.resetAllAttributes(true)
    this.createdMethod()
    this.$scrollTo({ y: 0 })
    this.loadHero = !!(this.breakpoint.current && this.breakpoint.current !== 'isMobile');
  },
  beforeRouteLeave (to, from, next) {
    this.$Search.resetAllAttributes()
    next()
  },
  methods: {
    createdMethod () {
      this.$Search.setAttributeValue('location', this.$route.params.location)
      this.$Search.setAttributeValue('limit_date', false)
      if (this.boat_type) {
        this.$Search.setAttributeValue('boatType', this.boat_type)
      }
      this.$Search.setAttributeValue('sortBy', '-premium_boat')
      this.$Search.search({ changeUrl: false })
    },
    async fetchFAQ (isVisible) {
      if (!isVisible) {
        return
      }
      if (this.pageFaq.loaded || this.pageFaq.loading) {
        return
      }
      if (!this.location?.ids?.country) {
        return
      }
      await this.$store.dispatch('page/fetchFAQ', {
        country_id: this.location.ids.country,
        defaultParam: 'null'
      }).catch((e) => {
        console.log(e)
      })
    },
    getSelectedFilterName (name, key) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.filters.hasOwnProperty(name)) {
        const object = this.filters[name].filter(item => item.key === parseInt(key, 10))

        // eslint-disable-next-line no-prototype-builtins
        return object[0] !== undefined && object[0] !== null && object[0].hasOwnProperty('name') ? object[0].name : ''
      }

      return ''
    }
  },
  jsonld () {
    const listItems = this.results.map((boat, index) => {
      return {
        '@type': 'ListItem',
        position: index + 1,
        item: {
          '@type': 'Product',
          name: boat.name,
          url: 'https://www.tubber.com' + this.$router.resolve({
            name: 'boat-view',
            params: { boatSlug: boat.slug },
            query: ''
          }).href,
          image: boat.thumbnail,
          Brand: boat.brand,

          additionalType: 'http://www.productontology.org/id/Yacht_charter',

          offers: {
            '@type': 'AggregateOffer',
            lowPrice: Math.round(boat.price.price / 7),
            highPrice: Math.round(boat.price.price / 7),
            priceCurrency: 'EUR',
            offerCount: 1
          }

        }
      }
    })
    const reviewListItems = this.staticReviews.map((review) => {
      return {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: 'Tubber',
        review: {
          '@type': 'Review',
          reviewRating: {
            '@type': 'Rating',
            ratingValue: review.rating,
            bestRating: 5,
            worstRating: 1
          },
          name: this.$t(review.title),
          author: {
            '@type': 'Person',
            name: this.$t(review.user_name)
          },
          reviewBody: this.$t(review.review_text)
        }
      }
    })
    return [
      {
        "@context": "https://schema.org",
        "@type": "TouristDestination",
        "name": this.location.location[this.location.type],
        "url":this.pageSeoData.url,
        "description": this.pageHead[this.locale].description,
        "touristType": {
          "@type": "Audience",
          "name": [this.$t('schema-audience').split(',')]
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": this.location.geo ? this.location.geo[this.location.type].latitude : '',
          "longitude": this.location.geo ? this.location.geo[this.location.type].longitude : ''
        },
        "image": this.pageSeoData.image
      },
      {
        name: 'Tubber',
        '@context': 'http://schema.org',
        '@type': 'ItemList',
        itemListElement: reviewListItems
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        itemListElement: listItems
      }]
  }
}
